import { render, staticRenderFns } from "./LineupHeading.vue?vue&type=template&id=12a4a5fe"
import script from "./LineupHeading.vue?vue&type=script&lang=js"
export * from "./LineupHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports